import styled from 'styled-components';
import { Card, Image } from 'antd';
import { colors } from 'styles/colors';
import tw from 'twin.macro';
import { fontSize } from 'styles/theme';

export const StyledCard = styled(Card)<any>`
  width: 100%;
  min-width: 100%;
  margin: 0;
  background-image: ${({ mobile }) =>
    mobile ? '' : "url('/images/elitetutor_card_background.png')"};
  background-align: left;
  background-repeat: no-repeat;
  background-color: ${({ mobile }) => (mobile ? colors.violetElite : '')};
  background-size: cover;
`;

export const StyledDescriptionCard = styled.div<any>`
  width: 100%;
`;

export const StyledDescriptionSubCard = styled.div<any>`
  width: 100%;
  max-width: 100%;
  background: ${colors.white};
  border-radius: ${({ mobile }) => (mobile ? '5px' : '0 10px 50px 0')};
  margin-bottom: ${({ mobile }) => (mobile ? '8px' : '')};
  padding: 15px;
`;

export const DescriptionHeadlineBox = styled.div`
  padding: 0px 0 5px 10px;
  display: grid;
  grid-template-areas: 'left right';
`;

export const DescriptionHeadline = styled.span`
  /* TODO: grid-area error: "Mismatched property value" -> use 'grid-template-areas: 'left';' instead? */
  grid-area: 'left';
  color: white;
  text-transform: uppercase;
  font-weight: 700;
`;

export const DescriptionRating = styled.span`
  /* TODO: grid-area error: "Mismatched property value" -> use 'grid-template-areas: 'right';' instead? */
  grid-area: 'right';
  color: white;
  font-weight: 700;
  text-align: center;
`;

export const DescriptionLevelSpan = styled.span`
  display: block;
  color: ${colors.blueGray};
  font-weight: 600;
  margin-bottom: 0.5em;
`;

export const DescriptionOwnSpecSpan = styled.span`
  display: block;
  height: 56px;
  max-height: 56px;
`;

export const CardItemContainer = styled.div<any>`
  ${tw`flex`};
  min-width: 100%;

  .group-wrap-item-cost {
    &:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      flex: 1;
    }
  }
`;

export const StyledBookALessonPill = styled.span`
  padding: 4px;
  border: 1px solid ${colors.gray8};
  grid-area: left;
  text-align: center;
  color: ${colors.white};
  background: ${colors.primary};
  border-radius: 14px;
  font-weight: 600;
`;

export const PriceSpan = styled.span`
  display: flex;
  align-items: center;
  margin-left: auto;
  grid-area: right;
  padding: 4px;
  font-size: ${fontSize.sm};
  color: ${colors.blueGray};
  font-weight: 400;
  text-align: center;
`;

export const BookALessonAndPriceBox = styled.div`
  display: grid;
  grid-template-areas: 'left right';
`;
